import { render, staticRenderFns } from "./SingleTPA.vue?vue&type=template&id=654c1589&scoped=true&"
import script from "./SingleTPA.vue?vue&type=script&lang=js&"
export * from "./SingleTPA.vue?vue&type=script&lang=js&"
import style0 from "./SingleTPA.vue?vue&type=style&index=0&id=654c1589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c1589",
  null
  
)

export default component.exports